import { Theme } from "@mui/material";
import { Link } from "react-router-dom";
import { SystemCssProperties } from "@mui/system";
import color from "context/MaterialUITheme/color";
import Typography from "@mui/material/Typography";

export type CLinkProps = {
  to: string;
  children: React.ReactNode;
  sx?: SystemCssProperties<Theme>;
};

const CLink: React.FC<CLinkProps> = ({ children, to, sx }) => {
  return (
    <Link to={to} style={{ textDecoration: "none" }}>
      <Typography
        sx={[
          {
            color: color.black,
            fontSize: "1.2rem",
            textDecoration: "none",
            padding: { md: "1rem", xs: 0 },
            fontFamily: "Pro Display Regular",
          },
          sx ? (sx as SystemCssProperties<Theme>) : null,
        ]}
      >
        {children}
      </Typography>
    </Link>
  );
};

export default CLink;
